import Vue from 'vue'
import lozad from 'lozad' 

export default class LozadDirective {
  static install () {
    Vue.directive('lozad', { // Create a new directive
      bind: (el, binding) => {
        // only 1 image to defer and no placeholder image
        if (typeof binding.value === 'string') {
          el.setAttribute('data-src', binding.value)
        } else {
          // include a placeholder image
          el.setAttribute('src', binding.value[0].placeholder)
          // 1 image to defer
          if (Object.keys(binding.value[0]).length < 4) {
            el.setAttribute('data-src', binding.value[0].image)
          } else {
            var mobile, tablet, desktop

            // use different recommended widths for Chrome
            if (navigator.userAgent.indexOf('Chrome') !== -1) {
              mobile = ' 700w, '
              tablet = ' 1500w, '
            } else {
              mobile = ' 1250w, '
              tablet = ' 2000w, '
            }
            desktop = ' 3000w'

            // mobile, tablet and desktop images to defer
            el.setAttribute('data-srcset', binding.value[0].mobile + mobile + binding.value[0].tablet + tablet + binding.value[0].desktop + desktop)
          }
        }
        let observerSet = lozad(el)
        observerSet.observe()
      }
    })
  }
}
